interface IGetHandleTopArgs {
    containerScrollTop: number;
    containerHeight: number;
    containerScrollHeight: number;
    scrollHandleHeight: number;
}

export const getHandleTop = ({
    containerScrollTop,
    containerHeight,
    containerScrollHeight,
    scrollHandleHeight,
}: IGetHandleTopArgs) => {
    // calculate handle scrolltop from center
    const visualContentCenter =
        (containerScrollTop * containerHeight) / (containerScrollHeight - containerHeight);

    /**
     * calculate handle offset based on current scroll top
     * handleOffset = based percentage on scrollTop to scrollHeight
     * we calculate the handleOffset proportion to containerHeight and handleHeight
     *
     * as user scrolls down - we keep adding offset to scrollTop of handle
     *
     * as it reaches end the offset is handleHeight - now handle wont cross container
     */
    const handleOffset =
        scrollHandleHeight -
        (scrollHandleHeight * containerScrollTop) / (containerScrollHeight - containerHeight);

    return visualContentCenter - scrollHandleHeight + handleOffset;
};

interface IGetScrollTopArgs {
    currentDragY: number;
    dragStartY: number;
    dragStartScrollTop: number;
    containerScrollHeight: number;
    containerHeight: number;
}

export const getScrollTop = ({
    currentDragY,
    dragStartY,
    dragStartScrollTop,
    containerScrollHeight,
    containerHeight,
}: IGetScrollTopArgs) => {
    const scrollDistance = currentDragY - dragStartY;
    const initialDistancePercentage = (dragStartScrollTop * 100) / containerScrollHeight;
    const newScrollTopPercentage =
        initialDistancePercentage + (scrollDistance * 100) / containerHeight;

    const scrollTop = (newScrollTopPercentage * containerScrollHeight) / 100;

    if (scrollTop < 0) {
        return 0;
    }

    if (scrollTop > containerScrollHeight - containerHeight) {
        return containerScrollHeight - containerHeight;
    }

    return scrollTop;
};
